<template>
  <div class="position-relative">
    <div
      v-show="showChatIcon && disableChat"
      id="popTargetChat"
      class="custom-popover chatPop"
    >
      <!--<span class="chat-count">2</span>-->
      <span class="boat-icon">
        <img
          src="@/assets/img/icons/chatboat/chat-white.png"
          width="25"
          class="img1"
          alt=""
        />
        <img
          src="@/assets/img/icons/chatboat/question-white.png"
          width="10"
          class="img2"
          alt=""
        />
      </span>
      <div id="popContainerChat"></div>
    </div>
    <b-popover
      @show="showPopBox"
      target="popTargetChat"
      triggers="click focus"
      placement="topleft"
      container="popContainerChat"
      no-fade
    >
      <ul class="chat-ul list-unstyled">
        <li>
          <b-link target="_blank" href="https://help.mailercloud.com/">
            <span class="ico">
              <img src="@/assets/img/icons/chatboat/help.png" alt="help" />
            </span>
            Help doc
          </b-link>
        </li>
        <li>
          <b-link
            target="_blank"
            href="https://feedback.mailercloud.com/updates"
          >
            <span class="ico">
              <img src="@/assets/img/icons/chatboat/bell.png" alt="new" />
            </span>
            What's new
          </b-link>
        </li>
        <li>
          <b-link
            target="_blank"
            href="https://feedback.mailercloud.com/boards/feature-requests"
          >
            <span class="ico">
              <img
                src="@/assets/img/icons/chatboat/feature-request.png"
                alt="feature request"
              />
            </span>
            Feature request
          </b-link>
        </li>
        <li>
          <b-link target="_blank" href="https://www.mailercloud.com/faqs">
            <span class="ico">
              <img src="@/assets/img/icons/chatboat/faq.png" alt="faq" />
            </span>
            FAQ
          </b-link>
        </li>
        <li>
          <b-link
            target="_blank"
            href="https://www.mailercloud.com/request-a-demo"
          >
            <span class="ico">
              <img
                src="@/assets/img/icons/chatboat/request-demo.png"
                alt="request demo"
              />
            </span>
            Request a demo
          </b-link>
        </li>
      </ul>
      <b-button
        @click="openModal"
        variant="outline-darker"
        block
        class="btn-with-ico img-invert round-10"
      >
        <img
          src="@/assets/img/icons/chatboat/support.png"
          width="24"
          alt=""
          class="mr-2"
        />Connect support
      </b-button>
    </b-popover>
    <b-modal
      @shown="showChatContainer"
      @hide="hideChatContainer"
      id="modalChatboat"
      no-close-on-backdrop
      modal-class="right modal-normal modal-chatboat"
      :body-class="
        showContent === 1 ? 'with-chat' : '' || formSubmit ? 'bg-primary' : ''
      "
      size="sm"
      hide-footer
      hide-backdrop
    >
      <template slot="modal-header">
        <b-row class="w-100" :class="showContent == 0 ? 'head-padd' : ''">
          <b-col>
            <b-row class="mb-4">
              <b-col>
                <h5 class="modal-title">
                  <a
                    @click="clickBack"
                    v-if="showContent !== 0"
                    href="javascript:void(0)"
                    class="text-white"
                  >
                    <img
                      src="@/assets/img/icons/chatboat/back-white.png"
                      width="18"
                      class="align-text-bottom"
                      alt=""
                    />Back</a
                  >
                </h5>
              </b-col>
              <b-col cols="auto">
                <button
                  type="button"
                  aria-label="Close"
                  class="close ml-0 text-white"
                  @click="$bvModal.hide('modalChatboat')"
                >
                  ×
                </button>
              </b-col>
            </b-row>
            <b-row v-if="!formSubmit" class="w-100">
              <b-col>
                <b-row no-gutters class="flex-nowrap">
                  <b-col cols="auto">
                    <h3 class="font-24 text-white text-truncate">
                      Hi
                      {{
                        userData.name
                          ? userData.name + " " + userData.last_name
                          : $ls.get("clientName")
                      }}
                    </h3>
                  </b-col>
                  <b-col><h3 class="font-24 text-white">👋</h3></b-col>
                </b-row>
                <p class="text-white">
                  We help you connect with your customers and grow your
                  business!
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
      <div v-if="formSubmit" class="text-center">
        <img
          src="@/assets/img/icons/chatboat/success-with-particle.png"
          width="192"
          class="mb-2"
          alt="success"
        />
        <h3 class="text-white font-24">Thank You!</h3>
        <p class="text-white font-15 mb-4">
          We appreciate you contacting Mailercloud. One of our colleagues will
          get back in touch with you soon!<br /><br />

          Have a great day!
        </p>
        <b-button @click="clickBack" variant="darker"> Ok </b-button>
      </div>
      <div v-else>
        <div id="my-messages-container" v-show="showContent === 1"></div>
        <div id="hbsptForm" class="pt-4" v-show="showContent === 2"></div>
        <div v-show="showContent === 0">
          <ul class="list-unstyled chat-btn-ul">
            <li>
              <a
                href="#"
                :class="{ disabled: !allowChatOption }"
                @click="showContent = 1"
              >
                <b-row>
                  <b-col>
                    <span class="ico">
                      <svg
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.00002 16.5C3.00068 13.5768 3.96199 10.7348 5.73599 8.41148C7.50999 6.08812 9.99837 4.41213 12.8182 3.64146C15.6379 2.87079 18.6328 3.04814 21.342 4.14623C24.0511 5.24432 26.3242 7.20228 27.8116 9.71878C29.299 12.2353 29.9182 15.1709 29.5739 18.0737C29.2295 20.9766 27.9407 23.6858 25.9059 25.7845C23.871 27.8832 21.2029 29.255 18.312 29.6888C15.4212 30.1226 12.4679 29.5943 9.90668 28.1854L4.72268 29.764C4.49146 29.8345 4.24543 29.8407 4.01093 29.7821C3.77643 29.7235 3.56226 29.6023 3.39134 29.4314C3.22042 29.2604 3.09918 29.0463 3.04059 28.8118C2.98199 28.5773 2.98825 28.3313 3.05868 28.1L4.63735 22.908C3.55989 20.9443 2.99665 18.7399 3.00002 16.5ZM11 15.1667C11 15.5203 11.1405 15.8595 11.3905 16.1095C11.6406 16.3595 11.9797 16.5 12.3333 16.5H20.3333C20.687 16.5 21.0261 16.3595 21.2762 16.1095C21.5262 15.8595 21.6667 15.5203 21.6667 15.1667C21.6667 14.8131 21.5262 14.4739 21.2762 14.2239C21.0261 13.9738 20.687 13.8334 20.3333 13.8334H12.3333C11.9797 13.8334 11.6406 13.9738 11.3905 14.2239C11.1405 14.4739 11 14.8131 11 15.1667ZM12.3333 19.1667C11.9797 19.1667 11.6406 19.3072 11.3905 19.5572C11.1405 19.8073 11 20.1464 11 20.5C11 20.8536 11.1405 21.1928 11.3905 21.4428C11.6406 21.6929 11.9797 21.8334 12.3333 21.8334H17.6667C18.0203 21.8334 18.3594 21.6929 18.6095 21.4428C18.8595 21.1928 19 20.8536 19 20.5C19 20.1464 18.8595 19.8073 18.6095 19.5572C18.3594 19.3072 18.0203 19.1667 17.6667 19.1667H12.3333Z"
                          fill="#020A13"
                        />
                      </svg>
                    </span>
                    {{
                      allowChatOption ? "Lets chat" : "Live chat unavailabe now"
                    }}
                  </b-col>
                  <b-col v-if="allowChatOption" cols="auto" class="ml-auto">
                    <div class="mc-avatars">
                      <span class="mc-avatar">
                        <img
                          src="https://avatars.hubspot.net/946103e8f62b753291988aa0650619a5-100"
                        />
                      </span>
                      <span class="mc-avatar">
                        <img
                          src="https://avatars.hubspot.net/fd3e4138fd7d0f209e56233b8654c83b-100"
                        />
                      </span>
                    </div>
                  </b-col>
                </b-row>
              </a>
            </li>
            <li>
              <a href="#" @click="showContent = 2">
                <b-row>
                  <b-col>
                    <span class="ico">
                      <svg
                        width="33"
                        height="33"
                        viewBox="0 0 33 33"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3.53327 11.7C3.53368 9.58649 4.23155 7.53217 5.51863 5.85574C6.8057 4.17931 8.61004 2.97448 10.6517 2.42815C12.6934 1.88181 14.8583 2.02452 16.8107 2.83413C18.763 3.64374 20.3935 5.075 21.4494 6.90588C22.5053 8.73675 22.9275 10.8649 22.6504 12.9602C22.3734 15.0555 21.4127 17.0008 19.9172 18.4943C18.4218 19.9879 16.4753 20.9462 14.3797 21.2206C12.284 21.495 10.1564 21.0702 8.32687 20.012L4.58607 21.26C4.44786 21.3062 4.29968 21.3137 4.15751 21.2818C4.01535 21.2499 3.88459 21.1797 3.77937 21.079C3.67414 20.9782 3.59843 20.8506 3.56042 20.7099C3.52241 20.5693 3.52353 20.4209 3.56367 20.2808L4.70287 16.2952C3.93329 14.886 3.53105 13.3057 3.53327 11.7ZM10.7333 9.30002C10.5211 9.30002 10.3176 9.3843 10.1676 9.53433C10.0176 9.68436 9.93327 9.88784 9.93327 10.1C9.93327 10.3122 10.0176 10.5157 10.1676 10.6657C10.3176 10.8157 10.5211 10.9 10.7333 10.9H15.5333C15.7454 10.9 15.9489 10.8157 16.099 10.6657C16.249 10.5157 16.3333 10.3122 16.3333 10.1C16.3333 9.88784 16.249 9.68436 16.099 9.53433C15.9489 9.3843 15.7454 9.30002 15.5333 9.30002H10.7333ZM13.9333 12.5H10.7333C10.5211 12.5 10.3176 12.5843 10.1676 12.7343C10.0176 12.8844 9.93327 13.0878 9.93327 13.3C9.93327 13.5122 10.0176 13.7157 10.1676 13.8657C10.3176 14.0157 10.5211 14.1 10.7333 14.1H13.9333C14.1454 14.1 14.3489 14.0157 14.499 13.8657C14.649 13.7157 14.7333 13.5122 14.7333 13.3C14.7333 13.0878 14.649 12.8844 14.499 12.7343C14.3489 12.5843 14.1454 12.5 13.9333 12.5Z"
                          fill="#020A13"
                        />
                        <path
                          d="M19.9748 24.4152L16.1316 22.4952C16.8356 22.2984 17.5124 22.036 18.1524 21.7144L20.3332 22.8056L27.5332 19.2056V18.1C27.5332 17.6757 27.3646 17.2687 27.0646 16.9687C26.7645 16.6686 26.3575 16.5 25.9332 16.5H23.2548C23.4996 15.988 23.7044 15.452 23.8692 14.9H25.9332C26.7819 14.9 27.5958 15.2372 28.1959 15.8373C28.7961 16.4374 29.1332 17.2513 29.1332 18.1V26.1C29.1332 26.9487 28.7961 27.7626 28.1959 28.3628C27.5958 28.9629 26.7819 29.3 25.9332 29.3H14.7332C13.8845 29.3 13.0706 28.9629 12.4705 28.3628C11.8703 27.7626 11.5332 26.9487 11.5332 26.1V22.788C12.0564 22.8616 12.5892 22.9 13.1332 22.9V26.1C13.1332 26.5244 13.3018 26.9313 13.6018 27.2314C13.9019 27.5315 14.3089 27.7 14.7332 27.7H25.9332C26.3575 27.7 26.7645 27.5315 27.0646 27.2314C27.3646 26.9313 27.5332 26.5244 27.5332 26.1V20.9944L20.6916 24.4152C20.5804 24.471 20.4576 24.5 20.3332 24.5C20.2088 24.5 20.0861 24.471 19.9748 24.4152Z"
                          fill="#020A13"
                        />
                      </svg>
                    </span>
                    Drop a mail
                  </b-col>
                </b-row>
              </a>
            </li>
          </ul>
          <b-card class="card-search-chat">
            <h3 class="font-15 text-dark mb-2">Search for help</h3>
            <b-input-group class="simple-v-search mb-4">
              <b-input-group-text slot="append"
                ><img
                  src="@/assets/img/icons/search.svg"
                  alt="search"
                  width="15"
              /></b-input-group-text>
              <b-form-input
                v-model="valueSearch"
                placeholder="Search in help doc"
                size="sm"
              ></b-form-input>
              <span class="active-bottom"></span>
            </b-input-group>
            <h3 class="mb-3 font-13 text-7d">Suggested articles</h3>
            <div class="chat-help-links font-13">
              <b-row v-if="articleData.length === 0" class="my-4">
                <b-col class="text-center">
                  <img
                    src="@/assets/img/theme/no-data-search.png"
                    width="120"
                    class="mb-4"
                    alt="no-data"
                  />
                  <h2 class="font-15 text-sub-head">
                    No related article found
                  </h2>
                  <p class="text-content mb-0 font-13 px-4">
                    Your searched term is not found in our suggested articles.
                    For more details, refer to our
                    <b-link
                      href="https://help.mailercloud.com/"
                      target="_blank"
                      class="text-underline"
                      >help documents</b-link
                    >.
                  </p>
                </b-col>
              </b-row>
              <b-link
                target="_blank"
                v-show="key < 5"
                v-for="(items, key) in articleData"
                v-bind:key="key"
                :href="items.link"
                class="link-dark"
                >{{ items.title }}</b-link
              >
              <b-link
                v-if="articleData.length != 0"
                target="_blank"
                href="https://help.mailercloud.com/"
                class="text-underline"
                >View all help docs</b-link
              >
            </div>
          </b-card>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { setHubspot, getHubspotToken } from "@/common/functions";

import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      showContent: 0,
      valueSearch: "",
      articleData: [],
      showChatIcon: true,
      disableChat: false,
      allowChatOption: true,
      rerenderChat: false,
      formSubmit: false,
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.profile.userData,
    }),
    ...mapGetters("chatbot", {
      articleItems: "getArticles",
    }),
  },
  watch: {
    valueSearch(search) {
      search = search.trim();
      var articles = JSON.parse(JSON.stringify(this.articleItems));
      if (search) {
        this.articleData = articles.filter(function (item) {
          return item.title.toLowerCase().includes(search.toLowerCase());
        });
      } else {
        this.articleData = articles;
      }
    },
  },
  mounted() {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/shell.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      if (window.hbspt && process.env.VUE_APP_HUBSPOT_CHAT_PORTAL_ID) {
        this.renderForm();
      }
    });

    window.addEventListener("message", (event) => {
      if (
        event.data.type === "hsFormCallback" &&
        event.data.eventName === "onFormSubmitted"
      ) {
        this.formSubmit = true;
      }
    });
  },
  methods: {
    renderForm() {
      var chatElement = document.getElementById("hbsptForm");
      if (chatElement) {
        chatElement.innerHTML = "";
      }
      window.hbspt.forms.create({
        portalId: process.env.VUE_APP_HUBSPOT_CHAT_PORTAL_ID,
        formId: process.env.VUE_APP_HUBSPOT_CHAT_FORM_ID,
        target: "#hbsptForm",
      });
    },
    clickBack() {
      this.showContent = 0;
      if (this.formSubmit) {
        this.formSubmit = false;
        this.renderForm();
        setHubspot(this, "embed");
      }
    },
    hideChatContainer() {
      this.showChatIcon = true;
      this.rerenderChat = false;
    },
    showPopBox() {
      var vm = this;
      var expireTime = this.$ls.get("hub_user_tokenexpire");
      if (expireTime) {
        var hour = 10;
        var exdate = parseInt(expireTime) + hour * 60 * 60 * 1000;
        if (exdate < new Date().getTime()) {
          vm.rerenderChat = true;
          getHubspotToken(vm);
        }
      } else {
        vm.rerenderChat = true;
        getHubspotToken(vm);
      }
    },
    openModal() {
      var vm = this;
      if (vm.rerenderChat) {
        setTimeout(() => {
          vm.showChatIcon = false;
          vm.$bvModal.show("modalChatboat");
        }, 2000);
      } else {
        vm.$bvModal.show("modalChatboat");
      }
    },
    showChatContainer() {
      var queryemail = "";
      if (this.$route.query && this.$route.query.email) {
        queryemail = this.$route.query.email;
      }
      if (this.$ls.get("username") !== queryemail) {
        this.$router.push({
          path: this.$route.path,
          query: { ...this.$route.query, email: this.$ls.get("username") },
        });
      }
      this.formSubmit = false;
      this.showChatIcon = false;
      setHubspot(this, "embed");
      this.renderForm();
      this.valueSearch = "";
      this.showContent = 0;
      this.articleData = JSON.parse(JSON.stringify(this.articleItems));

      // var chatElement = document.getElementById('hubspot-messages-iframe-container')
      // if (chatElement) {
      //  this.allowChatOption = true
      // } else {
      //  this.allowChatOption = false
      // }

      var currentTime = new Date();
      var currentOffset = currentTime.getTimezoneOffset();
      var ISTOffset = 330;
      var ISTTime = new Date(
        currentTime.getTime() + (ISTOffset + currentOffset) * 60000
      );
      let day = ISTTime.toLocaleString("en-us", { weekday: "long" });
      var leaveDay = ["Saturday", "Sunday"];

      var hoursIST = ISTTime.getHours();
      if (!leaveDay.includes(day) && hoursIST > 9 && hoursIST < 19) {
        this.allowChatOption = true;
      } else {
        this.allowChatOption = false;
      }
    },
  },
};
</script>
